export const formatDatesForGoodData = (dateStr: any) => {
  if (dateStr !== null) {
    dateStr = dateStr.split("/");
    return dateStr[2] + "-" + dateStr[0] + "-" + dateStr[1];
  }
  return "";
};
try {
    // @ts-ignore
    formatDatesForGoodData.displayName = "formatDatesForGoodData";
    // @ts-ignore
    formatDatesForGoodData.__docgenInfo = { "description": "", "displayName": "formatDatesForGoodData", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/utilities/formatDatesForGoodData.ts#formatDatesForGoodData"] = { docgenInfo: formatDatesForGoodData.__docgenInfo, name: "formatDatesForGoodData", path: "src/shared/containers/GoodData/utilities/formatDatesForGoodData.ts#formatDatesForGoodData" };
}
catch (__react_docgen_typescript_loader_error) { }